// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__3Ce7G","question":"Question_question__3s0F7","description":"Question_description__VuoQO"};